import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

import { IconRowHandle } from '@lightspeed/flame/Icon/RowHandle';

const MatrixAttributesDragHandle = SortableHandle(() => (
  <span className="matrix-attributes__handle">
    <IconRowHandle color="gray-300" />
  </span>
));

export default MatrixAttributesDragHandle;
